import { render, staticRenderFns } from "./PaketWisataPertanyaan.vue?vue&type=template&id=1df14ae2"
import script from "./PaketWisataPertanyaan.vue?vue&type=script&lang=js"
export * from "./PaketWisataPertanyaan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports